import angular from 'angular';
import Vue from 'vue';
import SupergroupList from './SupergroupList.vue';
import SupergroupListItem from './SupergroupListItem.vue';
import SupergroupUsers from './SupergroupUsers.vue';
import SupergroupForm from './SupergroupForm.vue';

// Export Vue components for direct import
export {
  SupergroupList,
  SupergroupListItem,
  SupergroupForm,
  SupergroupUsers,
};

// Register Vue components with Angular
const supergroupsModule = angular.module('adminPanel.adminEntities.supergroups', ['ngVue'])
  .directive('supergroupList', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('supergroup-list', SupergroupList));
  }])
  .directive('supergroupTreeItem', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('supergroup-list-item', SupergroupListItem));
  }])
  .directive('supergroupUsers', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('SupergroupUsers', SupergroupUsers));
  }])
  .directive('supergroupForm', ['createVueComponent', function(createVueComponent) {
    return createVueComponent(Vue.component('supergroup-form', SupergroupForm));
  }]);

export default supergroupsModule;